/**
 * Utilitários para formatação e validação de telefone
 */

/**
 * Aplica máscara de telefone brasileiro: (XX) XXXXX-XXXX
 */
export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  
  if (digits.length <= 2) {
    return digits ? `(${digits}` : '';
  } else if (digits.length <= 7) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  } else {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
  }
}

/**
 * Remove formatação do telefone, retornando apenas dígitos
 */
export function cleanPhone(phone: string): string {
  return phone.replace(/\D/g, '');
}

/**
 * Valida se o telefone tem 11 dígitos (DDD + número)
 */
export function isValidPhone(phone: string): boolean {
  const clean = cleanPhone(phone);
  return clean.length === 11;
}

/**
 * Aplica máscara de código PIN (6 dígitos)
 */
export function formatPinCode(code: string): string {
  return code.replace(/\D/g, '').slice(0, 6);
}

